import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FileSystemFileEntry, NgxFileDropEntry } from "ngx-file-drop";
import { RMAProvider } from "src/app/providers/rma.provider";
import { LogService } from "src/app/services";

@Component({
  selector: "app-rma-parsar",
  templateUrl: "./rma-parsar.component.html",
  styleUrls: ["./rma-parsar.component.scss"],
})
export class RmaParsarComponent implements OnInit {
  loading: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  errorMessage: string = "";
  subscription: any;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private rmaProvider: RMAProvider,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === "esc") this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }

  getRma() {
    this.rmaProvider.getRma().subscribe((data) => {});
  }

  fileDropped(files: NgxFileDropEntry[]): void {
    this.loading = true;
    const formData = new FormData();
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          formData.append("files", file);
        });
      }
    }

    this.rmaProvider.postRma(formData).subscribe(
      (data) => {
        if (data.success) {
          this.loading = false;
          this.isSuccess = true; // Set success flag to true
        } else {
          this.loading = false;
          this.isError = true;
          this.errorMessage =
            data.error?.txt || "Something went wrong! Please try again.";
        }
      },
      (err) => {
        this.logService.error(err);
        this.loading = false;
        this.bsModalRef.hide();
      }
    );
  }
}
